import { Home, FileText, MessageCircle, UserRound, ShoppingBag, Bell, Trophy, HeartPulse, Store, ShieldCheck, Star, AlertTriangle, Users, History, Calculator } from 'lucide-react';

/** Fixed bottom nav / desktop rail — exactly five destinations, in this order. */
export const PRIMARY_NAV = [
  { page: '', icon: Home, label: 'Home', id: 'home' },
  { page: 'prescriptions', icon: FileText, label: 'Rx', id: 'prescriptions', matches: ['prescriptions', 'refills', 'bills', 'verification', 'clinical'] },
  { page: 'shop', icon: Store, label: 'Shop', id: 'shop' },
  { page: 'chat', icon: MessageCircle, label: 'Chat', id: 'chat' },
  { page: 'profile', icon: UserRound, label: 'Account', id: 'profile' },
];

/** Secondary services, grouped for the Account page. */
export const ACCOUNT_GROUPS = [
  {
    id: 'my-care', title: 'My care', items: [
      { page: 'trackers', icon: HeartPulse, label: 'Health Trackers', id: 'trackers' },
      { page: 'reminders', icon: Bell, label: 'Reminders', id: 'reminders' },
      { page: 'dose-helper', icon: Calculator, label: 'Dose Helper', id: 'dose-helper' },
      { page: 'adverse-reactions', icon: AlertTriangle, label: 'Report a Reaction', id: 'adverse-reactions' },
    ],
  },
  {
    id: 'my-activity', title: 'My activity', items: [
      { page: 'history', icon: History, label: 'Full History', id: 'history' },
      { page: 'orders', icon: ShoppingBag, label: 'Orders', id: 'orders' },
      { page: 'shop', search: '?favourites=1', icon: Star, label: 'My Favourites', id: 'favourites' },
      { page: 'rewards', icon: Trophy, label: 'Rewards', id: 'rewards' },
    ],
  },
  {
    id: 'identity-access', title: 'Identity & access', items: [
      { page: 'family', icon: Users, label: 'Family Profiles', id: 'family' },
      { page: 'verify-id', icon: ShieldCheck, label: 'Verify My Identity', id: 'verify-id' },
    ],
  },
];
